<template>
    <div class="help-container">
      <h2 class="help-title">Ayuda para Gestión de Facturas</h2>
      <p class="help-introduction">Esta sección permite administrar las facturas generadas por servicios ofrecidos. Aquí puedes realizar acciones específicas relacionadas con el manejo de facturas:</p>
      <ul class="help-list">
        <li><strong>Buscar Facturas:</strong> Puedes buscar facturas por número, cédula del receptor o nombre, utilizando los campos de búsqueda proporcionados.</li>
        <li><strong>Generar CSV:</strong> Exporta la lista de facturas visible a un archivo CSV para su uso externo o análisis detallado.</li>
        <li><strong>Visualizar Todos los Registros:</strong> Utiliza el botón "Todos los registros" para ver todas las facturas almacenadas en el sistema sin filtros de búsqueda.</li>
        <li><strong>Agregar Nueva Factura:</strong> Crea una nueva factura utilizando el botón "Nuevo registro", que abre un formulario para ingresar los detalles necesarios.</li>
        <li><strong>Editar o Ver Detalles de Factura:</strong> Modifica o consulta detalles específicos de una factura seleccionando la opción correspondiente en el menú desplegable de acciones de cada factura.</li>
        <li><strong>Acciones Avanzadas:</strong> Dependiendo del estado de la factura, puedes generar planillas, facturas o realizar otras acciones administrativas directamente desde la tabla de facturas.</li>
      </ul>
      <p class="help-conclusion">Asegúrate de revisar cuidadosamente los datos antes de proceder con acciones que afecten el registro de facturas para garantizar la precisión en la gestión financiera.</p>
    </div>
  </template>
  
  <script>
  export default {
    name: "AyudaFacturas",
  };
  </script>
<style src="@/assets/css/ayuda.css" scoped></style>